import SmoothScroll from 'smooth-scroll';
export class Acc {
    constructor() {
        // アコーディオン複数の場合
        this.toggleMenus = {};

        //その他
        this.hasAccordion = false;
        this.accMinHeight = 300;
        this.scroll = {};
    }

    getStyle(e, styleName) {
        var styleValue = "";
        if (document.defaultView && document.defaultView.getComputedStyle) {
            styleValue = document.defaultView.getComputedStyle(e, "").getPropertyValue(styleName);
        } else if (e.currentStyle) {
            styleName = styleName.replace(/\-(\w)/g, function (strMatch, p1) {
                return p1.toUpperCase();
            });
            styleValue = e.currentStyle[styleName];
        }
        return styleValue.replace(/px/g, '');
    }

    init() {
        //console.log('acc init');
        if (document.getElementById('js-accordion')) {
            this.hasAccordion = true;

            // アコーディオン複数の場合
            this.toggleMenus = document.querySelectorAll('.js-accordion-btn');
            [].forEach.call(this.toggleMenus, (elem) => {
                //console.log(elem);
                elem.accElem = elem.parentElement.querySelector('.js-accordion-container');
                elem.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.accClickToggle(elem);
                });
            });

            //scroll
            this.scroll = new SmoothScroll();
            //this.scroll.init();
        }
    }

    accClickToggle(elem) {
        // アコーディオン複数の場合
        elem.contentHeight = elem.accElem.querySelector('.js-accordion-content').clientHeight;
        //console.log(elem.accElem + ', contentHeight=' + elem.contentHeight);
        if (elem.parentElement.classList.contains('open')) {
            elem.parentElement.classList.remove('open');
            elem.accElem.style.height = '0px';
            //console.log('closing , contentHeight=' + elem.contentHeight);
        } else {
            elem.parentElement.classList.add('open');
            elem.accElem.style.height = elem.contentHeight + 'px';
            //console.log('opening , contentHeight=' + elem.contentHeight);
        }
    }

    accResize() {
        //console.log('acc resize');
        if (this.hasAccordion) {
            //console.log('window resize -> acc1 resize');

            // アコーディオン複数の場合
            [].forEach.call(this.toggleMenus, (elem) => {
                elem.contentHeight = elem.parentElement.querySelector('.js-accordion-container').clientHeight;
                if (elem.parentElement.classList.contains('open')) {
                    elem.accElem.style.height = elem.contentHeight;
                }
            });
        }
    }

}